"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var ECOMMERCE_API_BASE = 'extensions/ecomm/v2';

var EcommerceV2Api =
/*#__PURE__*/
function () {
  function EcommerceV2Api() {
    (0, _classCallCheck2.default)(this, EcommerceV2Api);
  }

  (0, _createClass2.default)(EcommerceV2Api, null, [{
    key: "getStores",
    value: function getStores() {
      return _apiClient.default.get(ECOMMERCE_API_BASE + "/ui/stores");
    }
  }, {
    key: "getStoreDetails",
    value: function getStoreDetails(storeToken) {
      return _apiClient.default.get(ECOMMERCE_API_BASE + "/ui/stores/" + storeToken);
    }
  }, {
    key: "startImport",
    value: function startImport(storeToken) {
      return _apiClient.default.post(ECOMMERCE_API_BASE + "/imports/" + storeToken);
    }
  }, {
    key: "fetchImportDetails",
    value: function fetchImportDetails(storeToken) {
      return _apiClient.default.get(ECOMMERCE_API_BASE + "/imports/status/" + storeToken);
    }
  }, {
    key: "fetchStats",
    value: function fetchStats(storeToken) {
      return _apiClient.default.get(ECOMMERCE_API_BASE + "/stats/" + storeToken);
    }
  }, {
    key: "createEmbeddedWorkflow",
    value: function createEmbeddedWorkflow(_ref) {
      var storeToken = _ref.storeToken,
          emailType = _ref.emailType;
      return _apiClient.default.post(ECOMMERCE_API_BASE + "/workflows/" + storeToken + "/" + emailType);
    }
  }]);
  return EcommerceV2Api;
}();

exports.default = EcommerceV2Api;
module.exports = exports.default;